<template>
  <div>
    <div>
      <div class="row">
        <div class="col-md-6">
          <h5 class="card-title pull-left">{{ subscriptionPlan.name }}</h5>
        </div>
        <div class="col-md-6 col-sm-12">
          <h5
            class="card-title text-center pull-right"
            v-for="planItem in subscriptionPlan.plan_items"
            :key="planItem.id"
          >
            <small> {{ planItem.product.name }}. {{ !planItem.cycles ? "Mensal" : planItem.cycles + "x" }} -</small>
            {{ planItem.product.pricing_schema.short_format }} <br>
          </h5>
        </div>
      </div>
      <hr>
      <form>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <label>Cartão de Crédito: </label>
            <br />
            <el-select
              class="select-primary col-md-12"
              required
              size="large"
              v-model="customerProfile.customer_card_type"
              placeholder="Selecione..."
              @change="setCreditCardType()"
            >
              <el-option
                v-for="(option) in cardTypes"
                class="select-danger"
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </div>
          <div class="col-md-8 col-sm-12">
            <br>
            <img
              class="pull-right"
              src="static/img/card-buy.png"
              alt="logo"
            >
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-6 col-sm-12">
            <fg-input
              type="text"
              label="Número do cartão:"
              v-mask="''+creditCardMask"
              v-model="customerProfile.customer_card_number"
            >
            </fg-input>
          </div>
          <div class="col-md-6 col-sm-12">
            <fg-input
              type="text"
              id="the-card-name-id"
              label="Nome do titular:"
              placeholder="Como consta no cartão"
              v-model="customerProfile.customer_card_name"
            >
            </fg-input>
          </div>
        </div>
        <div class="row col-md-8 col-sm-12">
          <div class="col-md-3">
            <label>Vencimento: </label>
            <br />
            <el-select
              class="select-primary col-md-12"
              required
              size="large"
              v-model="customerProfile.customer_card_expiry_month"
              placeholder=""
            >
              <el-option
                v-for="(option) in monthsOfTheYear"
                class="select-danger"
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </div>
          <div class="col-md-4 col-sm-12">
            <label>Ano: </label>
            <br />
            <el-select
              class="select-primary col-md-12"
              required
              size="large"
              v-model="customerProfile.customer_card_expiry_year"
              placeholder=""
            >
              <el-option
                v-for="(option) in TenYearsFromNow"
                class="select-danger"
                :value="option"
                :label="option"
                :key="option"
              ></el-option>
            </el-select>
          </div>
          <div class="col-md-5 col-sm-12">
            <label>Cod. Segurança: </label>
            <br />
            <fg-input
              type="text"
              class="col-md-12"
              minlength="3"
              maxlength="4"
              v-mask="''+cvcMask"
              v-model="customerProfile.customer_card_cvc"
              placeholder="3 ou 4 Digítos"
            >
            </fg-input>
          </div>
        </div>
        <div class="clearfix"></div>
      </form>
      <hr>
      <div class="row">
        <div class="col-md-6 col-sm-12">
          <h5 class="card-title pull-left">Dados do Titular do Cartão</h5>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-12">
          <fg-input
            type="text"
            name="name"
            required
            placeholder="Nome"
            v-model="customerProfile.customer_name"
          ></fg-input>
        </div>
        <div class="col-md-12">
          <fg-input
            type="email"
            name="email"
            required
            placeholder="Email"
            v-model="customerProfile.customer_email"
          ></fg-input>
        </div>
        <div class="col-md-12">
          <fg-input
            type="text"
            required
            placeholder="CPF (Somente Números)"
            v-model="customerProfile.customer_cpf"
            v-mask="'###.###.###-##'"
          ></fg-input>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <fg-input
            type="text"
            required
            placeholder="CEP"
            maxlength="8"
            v-model="customerProfile.customer_cep"
          ></fg-input>
        </div>
        <div class="col-md-9 col-sm-12">
          <fg-input
            type="text"
            required
            placeholder="Endereço"
            v-model="customerProfile.customer_address"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-3 col-sm-12">
          <fg-input
            type="text"
            required
            placeholder="Número"
            v-model="customerProfile.customer_address_number"
          ></fg-input>
        </div>
        <div class="col-md-9 col-sm-12">
          <fg-input
            type="text"
            placeholder="Complemento"
            v-model="customerProfile.customer_address_complement"
          ></fg-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <el-select
            class="select-primary"
            required
            size="large"
            placeholder="País"
            v-model="customerProfile.customer_country"
          >
            <el-option
              v-for="(option) in countries"
              class="select-danger"
              :value="option.nome"
              :label="option.nome"
              :key="option.ordem"
            ></el-option>
          </el-select>
        </div>
        <div class="col-md-4 col-sm-12">
          <el-select
            class="select-primary"
            required
            size="large"
            placeholder="Estado"
            v-model="customerProfile.customer_state"
            @change="setStateIndex()"
          >
            <el-option
              v-for="option in states"
              class="select-danger"
              :value="option.nome"
              :label="option.nome"
              :key="option.sigla"
            ></el-option>
          </el-select>
        </div>
        <div class="col-md-4 col-sm-12">
          <el-select
            class="select-primary"
            required
            size="large"
            placeholder="Cidade"
            v-model="customerProfile.customer_city"
          >
            <el-option
              v-for="(option) in states[stateIndex].cidades"
              class="select-danger"
              :value="option"
              :label="option"
              :key="option"
            ></el-option>
          </el-select>
        </div>
      </div>
      <br>
      <div class="row">
        <div class="col-md-12">
          <fg-input
            type="text"
            required
            placeholder="Telefone (DDD + Número)"
            maxlength="11"
            v-model="customerProfile.customer_cellphone"
          ></fg-input>
        </div>
      </div>
      <br>
      <div class="row text-danger">
        <p v-if="formErrors.length">
          <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
        </p>
        <ul>
          <li
            v-for="error in formErrors"
            :key="error"
          >{{ error }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import { mask } from 'vue-the-mask'

// Utilities
import { BrazilianStates } from 'src//utils/modals/brazilian-states'
import { Countries } from 'src/utils/modals/countries'

export default {
  components: {
    [Select.name]: Select,
    [Option.name]: Option
  },
  props: {
    subscriptionPlan: Object
  },
  computed: {},
  directives: { mask },
  data () {
    return {
      formErrors: [],
      countries: Countries,
      states: BrazilianStates.estados,
      monthsOfTheYear: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      TenYearsFromNow: [],
      cardTypes: [
        'visa',
        'mastercard',
        'diners_club',
        'american_express',
        'elo'
      ],
      creditCardMask: '',
      cvcMask: '',
      stateIndex: 0,
      customerProfile: {
        customer_name: 'name',
        customer_email: 'email@email.com',
        customer_cpf: '014.835.462-92',
        customer_cellphone: '91980798024',
        customer_cep: '66085-148',
        customer_address: 'Address',
        customer_address_complement: 'Complment',
        customer_address_number: '1130',
        customer_city: 'Belem',
        customer_state: 'PA',
        customer_country: 'BRA',
        customer_is_foreign_country: '0',
        customer_card_number: '',
        customer_card_type: '',
        customer_card_name: '',
        customer_card_expiry_month: '',
        customer_card_expiry_year: '',
        customer_card_cvc: ''
      }
    }
  },
  methods: {
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validate () {
      this.formErrors = []

      if (
        !this.customerProfile.customer_name ||
        !this.customerProfile.customer_email ||
        !this.customerProfile.customer_cpf ||
        !this.customerProfile.customer_cellphone ||
        !this.customerProfile.customer_cep ||
        !this.customerProfile.customer_address ||
        !this.customerProfile.customer_address_number ||
        !this.customerProfile.customer_city ||
        !this.customerProfile.customer_state ||
        !this.customerProfile.customer_country ||
        !this.customerProfile.customer_card_number ||
        !this.customerProfile.customer_card_type ||
        !this.customerProfile.customer_card_name ||
        !this.customerProfile.customer_card_expiry_month ||
        !this.customerProfile.customer_card_expiry_year ||
        !this.customerProfile.customer_card_cvc
      ) {
        this.formErrors.push(
          'Todos os campos devem ser preenchidos obrigatoriamente.'
        )
        if (!this.validEmail(this.customerProfile.customer_email)) {
          this.formErrors.push('Utilize um e-mail válido.')
        }
        if (!this.customerProfile.customer_card_type) {
          this.formErrors.push('Número de cartão inválido.')
        }

        return false
      }

      if (!this.validEmail(this.customerProfile.customer_email)) {
        this.formErrors.push('Utilize um e-mail válido.')
      }

      if (!this.formErrors.length) {
        if (this.customerProfile.country === 'Brasil') {
          this.customerProfile.is_foreign_country = 0
        } else {
          this.customerProfile.is_foreign_country = 1
        }
        this.$emit('on-validated', true, this.customerProfile)
        // Scroll to top
        var element = document.getElementById('topDiv')
        var top = element.offsetTop
        window.scrollTo(0, top)
        return true
      } else {
        return false
      }
    },
    setStateIndex () {
      let index = 0
      this.customerProfile.city = ''
      for (let state of this.states) {
        if (state.nome === this.customerProfile.state) {
          this.stateIndex = index
        }
        index++
      }
    },
    setCreditCardType () {
      switch (this.customerProfile.customer_card_type) {
        case 'visa':
          this.creditCardMask = 'XXXX XXXX XXXX XXXX'
          this.cvcMask = 'XXX'
          break
        case 'mastercard':
          this.creditCardMask = 'XXXX XXXX XXXX XXXX'
          this.cvcMask = 'XXX'
          break
        case 'diners_club':
          this.creditCardMask = 'XXXX XXXXXX XXXX'
          this.cvcMask = 'XXX'
          break
        case 'american_express':
          this.creditCardMask = 'XXXX XXXXXX XXXXX'
          this.cvcMask = 'XXXX'
          break
        case 'elo':
          this.creditCardMask = 'XXXX XXXX XXXX XXXX'
          this.cvcMask = 'XXX'
          break
      }
    },
    validEmail: function (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  },
  created () {
    for (var i = parseInt(new Date().getFullYear(), 10); i <= parseInt(new Date().getFullYear(), 10) + 10; i++) {
      this.TenYearsFromNow.push(i)
    }
  }
}
</script>
<style>
input#the-card-name-id {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/WizardRecurringForms/SecondStep.vue